import { render, staticRenderFns } from "./ServicesBillingBtn.vue?vue&type=template&id=af4a16de&scoped=true"
import script from "./ServicesBillingBtn.vue?vue&type=script&lang=js"
export * from "./ServicesBillingBtn.vue?vue&type=script&lang=js"
import style0 from "./ServicesBillingBtn.vue?vue&type=style&index=0&id=af4a16de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af4a16de",
  null
  
)

export default component.exports